<template>
  <div class="detail-subject">
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li>
                        <router-link :to="{name: 'exercise'}">Lớp học</router-link>
                        <i class="secondary-color-txt fa fa-angle-right" style="margin-left: 5px;margin-right: 5px"></i>
                        <!-- <span><router-link :to="{ path: `/lop-hoc/noi-dung/${classLists.subjectId}` }">Lớp 1A - Môn Tiếng Việt</router-link></span> -->
                    </li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <!-- {{getListLesonPlan}} -->
                <DetailsubjectLeft/>
                <div class="col-lg-8 col-md-8 col-12 detail-right">
                   <ViewDicuss />
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import ViewDicuss from "../_components/ViewDiscuss"
import Discuss from "../_components/detail/Discuss"
import InfoClassLeft from "../_components/detail/InfoClassLeft"
import DetailsubjectLeft from "../_components/detailSubject/DetailsubjectLeft"
export default {
    name: "viewDetailDiscuss",
    data(){
        return{
           classSchoolSubjectId : this.$route.params.id,
        }
    },
    components: {
        ViewDicuss,
        InfoClassLeft,
        DetailsubjectLeft
    },
    computed: {
        ...mapGetters({
            subjectLists: STORE_KEY + "/subjectLists",
            classLists: STORE_KEY + "/classLists",
            getCourseDetail: STORE_KEY + "/getCourseDetail",
            getListLesonPlan: STORE_KEY + "/getListLesonPlan",

        })
    },
    mounted() {
        // this.actionGetListSubjectInWeek();
        // this.actionGetListClass();
        this.actionGetListLessonPlan();
        this.actionGetCourseDetail(this.classSchoolSubjectId)
    },
    methods: {
        ...mapActions(`${STORE_KEY}`, [ "actionGetListClass",'actionGetCourseDetail','actionGetListLessonPlan']),

    }
}

</script>

<style lang="scss" scoped>
    // .detail-right{
    //     margin:49px 0 100px 0;
       
    // }
    .dropdown-account{
        margin-left: 10px;
    }
    .dropdown button {
        width: 30px;
        background:#f3f6fb;
        color: #879AA9;
        font-size: 14px;
        text-align: center;
        border: 0px;
        padding-left: 0px;
        padding-right: 0px;
        border-radius: 30px;
        height: 30px;
        outline: 0;
    }
    .dropdown-item:hover,
    .dropdown-item:focus {
        color: #124abe;
        text-decoration: none;
        background: #f3f6fb;
    }
    .dropdown button:focus {
        background: #f3f6fb !important;
        color: #124ABE;
    }
    .dropdown-toggle::after {
        display:none;
    }
    .dropdown-menu {
        padding: 0rem 0 0.5rem;
        margin: 0.125rem 0 0;
        box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
        transform: translate3d(-95px, 30px, 0px) !important;
    }
    @media (max-width: 425px){
    .dropdown-menu {
        padding: 0rem 0 0.5rem;
        margin: 0.125rem 0 0;
        box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
        transform: translate3d(167px, 30px, 0px) !important;
    }
    .list-class .add-search{
        display: block;
        .btns{
            margin-bottom: 20px;
        }
    }
    }
</style>